const SvgDataDriven1 = (props) => (
  <>
    <path fill="none" stroke={props.p50} strokeMiterlimit={10} d="M96 0h96v96H96zM0 96h96v96H0zM96 192h96v96H96z" />
    <circle cx={95.4} cy={288.65} r={1.49} fill={props.p50} />
    <path fill="none" stroke={props.p50} strokeMiterlimit={10} d="M0 288h96v96H0z" />
    <circle cx={96} cy={288} r={4} fill={props.p50} />
    <circle cx={96} cy={96} r={4} fill={props.p50} />
    <circle cx={96} cy={192} r={4} fill={props.p50} />
  </>
);

export default SvgDataDriven1;
